import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type {
    CmsTargetAudienceArticleAttributeInterface,
    TargetAudienceInterface,
} from '~/src/repositories/cms/entities/main/types/cms.target-audience.types';

export const getMappedTargetAudienceData = (
    data: DictionaryInterface<CmsTargetAudienceArticleAttributeInterface>[] | [],
): TargetAudienceInterface[] => {
    return (data?.[0]?.articles || [])
        .reduce<TargetAudienceInterface[]>((targetAudienceData, elem) => {
            if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                const contentAttributes = elem.attributeCategories.komu_podoydet?.attributes;

                targetAudienceData.push({
                    id: elem.id,
                    image: contentAttributes?.image?.value || null,
                    hoverImage: contentAttributes?.hoverimage?.value || null,
                    title: contentAttributes?.title?.value || null,
                    subTitle: contentAttributes?.subtitle?.value || null,
                    order: contentAttributes?.order?.value || fallBackOrder,
                    sefUrl: elem?.sefUrl || null,
                });
            }

            return targetAudienceData;
        }, [])
        .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
};
